import src from "IMAGE";
export default { src, width: 1413, height: 270, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQUlEQVR42iXGOw6AMAgA0O4WTRMths+iEzgQ7n85Sfqm1/qyAUCPCMvMb4xxlL1AQ8STmZGILhGZ9Wlmj7u/qnr/vXwGXf9sU5sAAAAASUVORK5CYII="};
